export const colors = {
  primary_blue: '#003464',
  light_gray: '#f1f1f1',
  dark_gray: '#5A5A5A',
  alert_red: '#C70000',
  success_green: '#00A000',
};
